const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'Dostęp do interfejsu API',
    apiAppContent:
      'Dzięki interfejsowi API systemów Enlighten programiści mogą opracowywać aplikacje zewnętrzne, które odczytują dane produkcji energii przez system. Te aplikacje mogą prosić o podanie identyfikatora użytkownika w celu wysyłania próśb API w Twoim imieniu. Twój identyfikator użytkownika to %{user_id}.',
    showApp: 'Pokaż aplikacje, które mają dostęp do interfejsu API',
    isGrantedApp: 'Nie przyznano dostępu do interfejsu API żadnym aplikacjom.',
    apiSystemContent:
      'Zewnętrzna aplikacja może pobierać dane tylko dla systemów, które zezwalają na dostęp do interfejsu API. Jest to kontrolowane przez właściciela systemu. Jeśli system, który możesz wyświetlić, nie jest tutaj wymieniony, oznacza to, że właściciel nie zezwala na dostęp do interfejsu API.',
    showSystem: 'Pokaż systemy, które zezwalają na dostęp do interfejsu API',
    isGrantedSystem: 'Nie przyznano dostępu do interfejsu API żadnym systemom.',
    revokeAccess: 'Odwołaj dostęp'
  }
};

export default apiAccess;
